import { Controller } from '@hotwired/stimulus';
import {show, hide} from "../helpers";

export default class extends Controller {
  connect() {
    this.submitButton = this.element.querySelector('#clientInfoSubmit');

    this.element.querySelectorAll('.editable-value-wrapper').forEach((el)=> {
      el.querySelector('.btn-edit').addEventListener('click', (e)=> {
        show(this.submitButton);
        hide(el.querySelector('.value'));
        show(el.querySelector('.value-field'));
        hide(el.querySelector('.btn-edit'))
      })
    })
  }
}
